import { StyleSheet, I18nManager, Platform } from 'react-native';

export default StyleSheet.create({
  closeButtonContainerStyle: {
    padding: 7,
  },
  headerContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 20,
    marginLeft: I18nManager.isRTL ? 13 : 20,
    marginRight: I18nManager.isRTL ? 20 : 13,
    marginTop: Platform.OS === 'ios' ? 20 : 50,
  },
});
